(function () {
  var STORAGE_KEY = 'sach_wishlist';

  function getWishlist() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : [];
    } catch (e) { return []; }
  }

  function saveWishlist(list) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
  }

  function isInWishlist(handle) {
    return getWishlist().indexOf(handle) !== -1;
  }

  function addToWishlist(handle) {
    var list = getWishlist();
    if (list.indexOf(handle) === -1) { list.push(handle); saveWishlist(list); }
  }

  function removeFromWishlist(handle) {
    var list = getWishlist().filter(function (h) { return h !== handle; });
    saveWishlist(list);
  }

  function toggleWishlist(handle) {
    if (isInWishlist(handle)) { removeFromWishlist(handle); return false; }
    addToWishlist(handle); return true;
  }

  function updateButtonStates() {
    var list = getWishlist();
    document.querySelectorAll('[data-wishlist-toggle]').forEach(function (btn) {
      var handle = btn.getAttribute('data-handle');
      if (list.indexOf(handle) !== -1) {
        btn.classList.add('is-active');
        btn.setAttribute('aria-pressed', 'true');
      } else {
        btn.classList.remove('is-active');
        btn.setAttribute('aria-pressed', 'false');
      }
    });
  }

  function updateCountBadges() {
    var count = getWishlist().length;
    document.querySelectorAll('.wishlist-count').forEach(function (el) {
      el.textContent = count;
      if (count > 0) { el.classList.add('show'); } else { el.classList.remove('show'); }
    });
  }

  function refreshUI() {
    updateButtonStates();
    updateCountBadges();
  }

  function renderWishlistPage() {
    var grid = document.getElementById('wishlist-grid');
    var emptyState = document.getElementById('wishlist-empty');
    if (!grid) return;
    var handles = getWishlist();

    if (handles.length === 0) {
      grid.innerHTML = '';
      if (emptyState) emptyState.classList.add('show');
      return;
    }
    if (emptyState) emptyState.classList.remove('show');
    grid.innerHTML = '';

    handles.forEach(function (handle) {
      fetch('/products/' + handle + '.js')
        .then(function (res) {
          if (!res.ok) throw new Error('not found');
          return res.json();
        })
        .then(function (product) {
          var price = (product.price / 100).toFixed(2).replace('.', ',');
          var image = product.featured_image || (product.images && product.images[0]) || '';
          var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || '';
          var card = document.createElement('div');
          card.className = 'wishlist-card';
          card.innerHTML =
            '<button type="button" class="wishlist-remove-btn" data-wishlist-toggle data-handle="' + handle + '" aria-label="Quitar de favoritos">' +
              '<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13 1L1 13M13 13L1 1" stroke="#151515" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
            '</button>' +
            '<a href="/products/' + handle + '">' +
              (image ? '<img src="' + image + '" alt="" loading="lazy">' : '') +
            '</a>' +
            '<div class="wishlist-card-info">' +
              '<a href="/products/' + handle + '" class="wishlist-card-title">' + product.title + '</a>' +
              '<div class="wishlist-card-price">' + price + ' ' + currency + '</div>' +
            '</div>';
          grid.appendChild(card);
        })
        .catch(function () {
          removeFromWishlist(handle);
        });
    });
  }

  function syncMobileAddToCart() {
    var real = document.querySelector('.single-add-to-cart-button');
    var proxy = document.querySelector('.mobile-quick-add-to-cart-btn');
    if (!real || !proxy) return;
    if (real.disabled) {
      proxy.setAttribute('disabled', 'disabled');
    } else {
      proxy.removeAttribute('disabled');
    }
    var realText = real.querySelector('.single-add-to-cart-button--text');
    if (realText && realText.textContent.trim() !== '') {
      proxy.textContent = realText.textContent.trim();
    }
  }

  function navigateCard(navBtn) {
    var figure = navBtn.closest('.product-featured-image');
    if (!figure) return;
    var slides = figure.querySelectorAll('.product-card-slide');
    if (slides.length < 2) return;
    var currentIndex = 0;
    slides.forEach(function (s, i) {
      if (s.classList.contains('is-active')) { currentIndex = i; }
    });
    var newIndex;
    if (navBtn.classList.contains('product-card-nav-next')) {
      newIndex = (currentIndex + 1) % slides.length;
    } else {
      newIndex = (currentIndex - 1 + slides.length) % slides.length;
    }
    slides[currentIndex].classList.remove('is-active');
    slides[newIndex].classList.add('is-active');
  }

  document.addEventListener('click', function (e) {
    var navBtn = e.target.closest('.product-card-nav');
    if (navBtn) {
      e.preventDefault();
      e.stopPropagation();
      if (e.stopImmediatePropagation) { e.stopImmediatePropagation(); }
      navigateCard(navBtn);
      return;
    }

    var wishBtn = e.target.closest('[data-wishlist-toggle]');
    if (wishBtn) {
      e.preventDefault();
      e.stopPropagation();
      if (e.stopImmediatePropagation) { e.stopImmediatePropagation(); }
      var handle = wishBtn.getAttribute('data-handle');
      if (handle) {
        toggleWishlist(handle);
        refreshUI();
        if (document.getElementById('wishlist-grid')) { renderWishlistPage(); }
      }
      return;
    }

    var mobileBtn = e.target.closest('.mobile-quick-add-to-cart-btn');
    if (mobileBtn) {
      var realBtn = document.querySelector('.single-add-to-cart-button');
      if (realBtn && !realBtn.disabled) { realBtn.click(); }
      return;
    }
  }, true);

  document.addEventListener('DOMContentLoaded', function () {
    refreshUI();
    syncMobileAddToCart();
    if (document.getElementById('wishlist-grid')) { renderWishlistPage(); }
  });

  document.addEventListener('variant:change', syncMobileAddToCart);
  document.addEventListener('change', function (e) {
    if (e.target.closest('variant-selects')) {
      setTimeout(syncMobileAddToCart, 150);
    }
  });

  window.SachWishlist = {
    add: addToWishlist,
    remove: removeFromWishlist,
    toggle: toggleWishlist,
    isSaved: isInWishlist,
    refresh: refreshUI
  };
})();
